/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * Represents metadata of a redeemable NFT reward
 * @export
 * @interface NftRewardMetadata
 */
export interface NftRewardMetadata {
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftRewardMetadata
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftRewardMetadata
     */
    updatedAt: number;
    /**
     * 
     * @type {NftTracker}
     * @memberof NftRewardMetadata
     */
    nftTracker: NftTracker;
    /**
     * ABI of the NFT contract
     * @type {string}
     * @memberof NftRewardMetadata
     */
    contractAbi: string;
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    origin?: string;
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftRewardMetadata
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftRewardMetadata
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Asset}
     * @memberof NftRewardMetadata
     */
    image?: Asset;
    /**
     * 
     * @type {Asset}
     * @memberof NftRewardMetadata
     */
    redemptionAnimation?: Asset;
    /**
     * If enabled, a sparkle transition effect will display over the redemption image when reward is being redeemed
     * @type {boolean}
     * @memberof NftRewardMetadata
     */
    transitionEffectEnabled?: boolean;
}

/**
 * Check if a given object implements the NftRewardMetadata interface.
 */
export function instanceOfNftRewardMetadata(value: object): value is NftRewardMetadata {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('nftTracker' in value) || value['nftTracker'] === undefined) return false;
    if (!('contractAbi' in value) || value['contractAbi'] === undefined) return false;
    return true;
}

export function NftRewardMetadataFromJSON(json: any): NftRewardMetadata {
    return NftRewardMetadataFromJSONTyped(json, false);
}

export function NftRewardMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftRewardMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'nftTracker': NftTrackerFromJSON(json['nftTracker']),
        'contractAbi': json['contractAbi'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'relayerUrl': json['relayerUrl'] == null ? undefined : json['relayerUrl'],
        'forwarderAddress': json['forwarderAddress'] == null ? undefined : json['forwarderAddress'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'image': json['image'] == null ? undefined : AssetFromJSON(json['image']),
        'redemptionAnimation': json['redemptionAnimation'] == null ? undefined : AssetFromJSON(json['redemptionAnimation']),
        'transitionEffectEnabled': json['transitionEffectEnabled'] == null ? undefined : json['transitionEffectEnabled'],
    };
}

export function NftRewardMetadataToJSON(json: any): NftRewardMetadata {
    return NftRewardMetadataToJSONTyped(json, false);
}

export function NftRewardMetadataToJSONTyped(value?: NftRewardMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'nftTracker': NftTrackerToJSON(value['nftTracker']),
        'contractAbi': value['contractAbi'],
        'origin': value['origin'],
        'title': value['title'],
        'description': value['description'],
        'relayerUrl': value['relayerUrl'],
        'forwarderAddress': value['forwarderAddress'],
        'isEnabled': value['isEnabled'],
        'image': AssetToJSON(value['image']),
        'redemptionAnimation': AssetToJSON(value['redemptionAnimation']),
        'transitionEffectEnabled': value['transitionEffectEnabled'],
    };
}

